// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1mP5x","errorLogs":"EditorFooter_errorLogs__3MMy3"};